import React from 'react';
import OwnFactsheetScreen from './OwnFactsheetScreen';

export default (props: any) => (
  <OwnFactsheetScreen {...props} comments={true} />
);
